import { AxiosResponse } from 'axios';
import { ApiSalesDashboardService } from 'services';
import endpoints from 'constants/endpoints';
import { IMcpUserSaved, IMcpUserUpsert, IMcpUsersResponse } from './types';

/** El máximo que acepta la API por página: la lista es corta y se trae entera. */
export const MCP_USERS_PAGE_LIMIT = 500;

export const getMcpUsers = (): Promise<AxiosResponse<IMcpUsersResponse>> =>
	ApiSalesDashboardService.get(endpoints.mcpConnector.users, { params: { limit: MCP_USERS_PAGE_LIMIT, offset: 0 } });

export const saveMcpUser = (body: IMcpUserUpsert): Promise<AxiosResponse<{ success: boolean; data: IMcpUserSaved }>> =>
	ApiSalesDashboardService.put(endpoints.mcpConnector.users, body);
